import { Vector3 } from '@babylonjs/core';
import { ObstacleDistributionConfig } from '../ObstacleGenerator';
import { ObstacleBehavior } from './ObstacleBehavior';

export class ObstacleJumpBehavior extends ObstacleBehavior {
  private time: number = 0;
  constructor(startPosition: Vector3, pathIndex: number, config: ObstacleDistributionConfig) {
    super('obstacleJump', startPosition, pathIndex, config);
  }
  update(deltaTime: number): void {
    this.time += deltaTime * this.config.speed;
    // Simple absolute value for bounce/hop effect from ground
    const yOffset = Math.abs(Math.sin(this.time)) * this.config.height;
    this.mesh.position.y = this.startPosition.y + yOffset;

    if (this.config.crumple) {
      const flattenFactor = 1 - Math.abs(Math.sin(this.time));
      this.mesh.scaling.y = this.startScale.y * (1 - flattenFactor * this.config.crumple);
    }
  }
  clone(): ObstacleJumpBehavior {
    return new ObstacleJumpBehavior(this.startPosition, this.pathIndex, this.config);
  }
}
